import React, { useEffect } from "react";
import moment from "moment";
import {
  Button,
  Iconography,
  IconographySizes,
} from "@hid-galaxy-ui/galaxy-react";
import { useNavigate } from "react-router-dom";
import SummarySection from "./SummarySection";
import LicensesSection from "./LicensesSection";
import PointsAcceleratorsSection from "./PointsAcceleratorsSection";
import EngagementActivitiesSection from "./EngagementActivitiesSection";
import CommentsFilesSection from "./CommentsFilesSection";
import "./Detail.scss";
import { getOverviewEventListing } from "../../../../../redux/saga/partner-program/calculator/saga-action";
import { useAppDispatch,useAppSelector } from "../../../../../redux";
import { AnyARecord } from "dns";

interface DetailProps {
  onBack?: () => void;
  selectedAssesmentData:any;
  summaryDat:any
}

const Detail: React.FC<DetailProps> = ({ onBack,selectedAssesmentData,summaryDat }) => {
  console.log("selectedAssesmentData",selectedAssesmentData)
  const navigate = useNavigate();
 const dispatch = useAppDispatch();
  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  };

    const {
        partnerEngagementConfigurationList } = useAppSelector(
          (state) => state.partner_engagementConfiguration
        );

        console.log("partnerEngagementConfigurationList",partnerEngagementConfigurationList)
    useEffect(() => {
   
        // dispatch(getOverviewEventListing());
      
    }, []);

  return (
    <>
      <div className="detail-header">
        <button className="back-button" onClick={handleBack}>
          <Iconography icon="arrowLeft" size={IconographySizes.Small} />
          BACK TO OVERVIEW
        </button>
        <div className="assessment-banner">
          <h1>
            Assessment Day -{" "}{moment(selectedAssesmentData.assessment_date).format("DD-MM-YYYY")}
          </h1>
        </div>
      </div>

      <div className="detail-container">
      <div className="detail-content">
        <SummarySection
        selectedAssesmentData={selectedAssesmentData}
        summaryDat={summaryDat}
        isEditable={false} />
        <LicensesSection
          selectedAssesmentData={selectedAssesmentData}
        isEditable={false} />
        <PointsAcceleratorsSection
        selectedAssesmentData={selectedAssesmentData}
        isEditable={false} />
        <div className="detail-section full-width">
          <EngagementActivitiesSection
          selectedAssesmentData={selectedAssesmentData}
          />
        </div>
        <div className="detail-section full-width">
          <CommentsFilesSection 
          selectedAssesmentData={selectedAssesmentData}
          isEditable={false} />
        </div>
      </div>
    </div>
    </>
  );
};

export default Detail;
